const divCardTimeline = {
  inspected_by: 'Inspected by'
};

export default divCardTimeline;
